if (!customElements.get('multicolumn-expandable')) {
  class MulticolumnExpandable extends HTMLElement {
    constructor() {
      super();
      this.panel = null;
      this.activeItem = null;
      this.boundResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.panel = this.querySelector('.multicolumn-expandable__panel');
      if (!this.panel) return;

      this.grid = this.querySelector('.multicolumn-list');
      this.setupListeners();
      window.addEventListener('resize', this.boundResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundResize);
    }

    setupListeners() {
      this.getColumnItems().forEach((item) => {
        const card = item.querySelector('.multicolumn-card');
        if (card) {
          card.addEventListener('click', () => this.handleItemClick(item));
        }
      });

      const closeBtn = this.panel.querySelector('.multicolumn-expandable__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.closePanel());
      }
    }

    getColumnItems() {
      return [...this.grid.querySelectorAll(':scope > .multicolumn-list__item:not(.multicolumn-expandable__panel)')];
    }

    handleResize() {
      if (this.activeItem && !this.panel.hidden) {
        this.positionPanel(this.activeItem);
      }
    }

    handleItemClick(item) {
      if (this.activeItem === item) {
        this.closePanel();
        return;
      }

      if (this.activeItem) {
        this.activeItem.classList.remove('multicolumn-list__item--active');
      }

      this.activeItem = item;
      item.classList.add('multicolumn-list__item--active');

      const description = item.querySelector('.multicolumn-card__description');
      const panelContent = this.panel.querySelector('.multicolumn-expandable__content');
      if (description && panelContent) {
        panelContent.innerHTML = description.innerHTML;
      }

      this.positionPanel(item);

      this.panel.hidden = false;
      this.panel.offsetHeight;
      this.panel.classList.add('multicolumn-expandable__panel--open');

      setTimeout(() => {
        this.panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }

    positionPanel(item) {
      // Temporarily move panel to end to not affect row calculations
      this.panel.hidden = true;
      this.grid.appendChild(this.panel);
      this.grid.offsetHeight;

      const items = this.getColumnItems();
      const itemRect = item.getBoundingClientRect();
      const itemIndex = items.indexOf(item);

      // Find the last item that shares the same visual row (same top position)
      let lastInRow = item;
      for (let i = itemIndex + 1; i < items.length; i++) {
        const otherRect = items[i].getBoundingClientRect();
        if (Math.abs(otherRect.top - itemRect.top) < 10) {
          lastInRow = items[i];
        } else {
          break;
        }
      }

      lastInRow.after(this.panel);
    }

    closePanel() {
      this.panel.classList.remove('multicolumn-expandable__panel--open');
      if (this.activeItem) {
        this.activeItem.classList.remove('multicolumn-list__item--active');
        this.activeItem = null;
      }
      setTimeout(() => {
        this.panel.hidden = true;
      }, 300);
    }
  }

  customElements.define('multicolumn-expandable', MulticolumnExpandable);
}
